var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"photoWindow",style:({ height: _vm.photoWindowHeight })},[_c('img',{staticClass:"d-block image-card-photo",attrs:{"src":_vm.photo ? _vm.photo : _vm.defaultImage,"alt":"Company Photo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }